var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('iq-card',{staticClass:"image_modal_card"},[[(_vm.propImageUrl.includes('<img src'))?_c('p',{staticClass:"image_view vhtmlUlLi",domProps:{"innerHTML":_vm._s(_vm.propImageUrl)}}):_c('img',{attrs:{"src":_vm.propImageUrl}})]],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }